const podStatus = {
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  RETURNED: 'RETURNED',
};

export { podStatus };
